let settings = {
	env: process.env.NODE_ENV,
	reactAppEnv: process.env.REACT_APP_ENV,
	jwPlayerKey: "2Dvm5V83EZW7XEydV6lA99EQ3CTc0zgtbMQ/4MZnBqSxFkR4",
	prodegeKeys: {
		secret_key: "sYMXtNfyEBwUFpzOTjymvQAOggsqwlMAktMzueqdAIvOsvXluYaTISxDtqySncgy",
		apik: "PAT!HMpwEa8t$I",
		byk: "SEcW6IdyHauYF*B"
	}
};

if (process.env.REACT_APP_ENV === 'production') {

	settings.isDev = false;

	settings.portal_url = "https://portal.pilot.ly";
	settings.api_host = "https://portal-api.pilot.ly";
	settings.follow_up_agent_host = "https://follow-up-agent.pilotly.tech";
	settings.moderated_host = "https://reelchat.pilot.ly";
	settings.gaCode = "G-7HTDJYSJQC";

	settings.loggingEnabled = false;
	settings.geoEnabled = true;

} else if (process.env.REACT_APP_ENV === 'staging') {

	settings.isDev = true;

	settings.portal_url = "https://portal-staging.pilot.ly";
	settings.api_host = "https://portal-api-staging.pilot.ly";
	settings.follow_up_agent_host = "https://follow-up-agent.pilotly.tech";
	settings.moderated_host = "https://reel-staging.pilot.ly";
	settings.gaCode = "G-N36HBRNLM0";

	settings.loggingEnabled = true;
	settings.geoEnabled = false;

} else if (process.env.REACT_APP_ENV === 'qa') {

	settings.isDev = true;

	settings.portal_url = "https://portal-qa.pilot.ly";
	settings.api_host = "https://portal-api-qa.pilot.ly";
	settings.follow_up_agent_host = "https://follow-up-agent.pilotly.tech";
	settings.moderated_host = "https://reel-chime.pilot.ly";
	settings.gaCode = "G-N36HBRNLM0";

	settings.loggingEnabled = true;
	settings.geoEnabled = false;

} else if (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'clone') {

	settings.isDev = true;

	settings.portal_url = "https://portal-dev.pilot.ly";
	settings.api_host = "https://portal-api-dev.pilot.ly";
	settings.follow_up_agent_host = "https://follow-up-agent.pilotly.tech";
	settings.moderated_host = "https://reel-dev.pilot.ly";
	settings.gaCode = "G-N36HBRNLM0";

	settings.loggingEnabled = true;
	settings.geoEnabled = false;

} else {

	settings.isDev = true;

	// settings.portal_url = "https://portal-dev.pilot.ly";
	// settings.portal_url = "https://portal-qa-old.pilot.ly";
	settings.portal_url = "https://portal-qa.pilot.ly";
	// settings.portal_url = "https://portal.pilot.ly";
	// settings.api_host = "http://127.0.0.1:7071";
	// settings.api_host = "https://portal-api.pilot.ly";
	// settings.api_host = "https://portal-api-dev.pilot.ly";
	settings.api_host = "https://portal-api-qa.pilot.ly";
	settings.follow_up_agent_host = "https://follow-up-agent.pilotly.tech";
	// settings.moderated_host = "https://localhost:4444";
	settings.moderated_host = "https://reel-chime.pilot.ly";
	settings.gaCode = "G-N36HBRNLM0";

	settings.loggingEnabled = true;
	settings.geoEnabled = false;
}

settings.portal_player_base = settings.portal_url + "/portal-player";
settings.portal_player_url = settings.portal_player_base + "/players/portal_player.html";
// settings.portal_player_url = settings.portal_player_base + "/players/mobile_player.html";
// console.log("config.js: settings", settings);

export default settings;


// WEBPACK FOOTER //
// ./src/libs/config.js